module.exports = __webpack_public_path__ + "static/media/OstomyUserPrivacy.a253fc1c.txt";